"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
// Icons
var AddIcon_svg_1 = __importDefault(require("@src/containers/FAQNodes/icons/AddIcon.svg"));
var ActionCard_1 = __importDefault(require("./ActionCard"));
var StyledComponets_1 = require("./StyledComponets");
var Actions = function (_a) {
    var allActions = _a.allActions, onConfigure = _a.onConfigure, onDelete = _a.onDelete, onNewAction = _a.onNewAction;
    return (react_1["default"].createElement(box_1["default"], { padding: "0", style: { display: 'grid', flex: 1, alignContent: 'baseline' } },
        react_1["default"].createElement(box_1["default"], { padding: "0", style: { display: 'grid' } },
            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, "Actions"),
            react_1["default"].createElement(StyledComponets_1.StyledText, { marginBottom: "16px" }, "These are the individual actions the agent will perform. Actions can include \"making an API call\" or \"running a custom Python script.\""),
            allActions.map(function (action) { return (react_1["default"].createElement(ActionCard_1["default"], { title: action === null || action === void 0 ? void 0 : action.name, description: action === null || action === void 0 ? void 0 : action.description, onConfigure: onConfigure, onDelete: onDelete, id: action === null || action === void 0 ? void 0 : action.id })); })),
        react_1["default"].createElement(StyledComponets_1.StyledAddActionButton, null,
            react_1["default"].createElement(icon_1["default"], { src: AddIcon_svg_1["default"], onClick: onNewAction }),
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "blue.haptik", onClick: onNewAction },
                ' ',
                allActions.length ? 'Add another Action' : 'Add Action'))));
};
exports["default"] = Actions;
